import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { createdResponse, notFoundResponse, removedResponse, updatedResponse } from '../../routes/defaultResponses';

const equipmentTypeFieldSchema = Type.Object({
    id: Type.String(),
    equipmentTypeId: Type.String(),
    name: Type.String({ minLength: 1 }),
    fieldOrder: Type.Integer({ minimum: 0 }),
});

const equipmentTypeFieldCreateAndUpdateSchema = Type.Pick(equipmentTypeFieldSchema, ['name', 'fieldOrder']);

export const equipmentTypeFieldPaths = {
    '/api/equipmentTypes/{equipmentTypeId}/fields': {
        get: {
            operationId: 'equipmentTypeFieldControllers.getAll',
            parameters: [createPathGuidParameter('equipmentTypeId')],
            responses: {
                '200': {
                    description: 'Array of equipment type fields',
                    content: {
                        'application/json': {
                            schema: Type.Object({ items: Type.Array(equipmentTypeFieldSchema) }),
                        },
                    },
                },
                ...notFoundResponse,
            },
        },
        post: {
            parameters: [createPathGuidParameter('equipmentTypeId')],
            operationId: 'equipmentTypeFieldControllers.create',
            requestBody: {
                content: {
                    'application/json': {
                        schema: equipmentTypeFieldCreateAndUpdateSchema,
                    },
                },
            },
            responses: {
                ...createdResponse,
                ...notFoundResponse,
            },
        },
    },
    '/api/equipmentTypes/{equipmentTypeId}/fields/{equipmentTypeFieldId}': {
        parameters: [createPathGuidParameter('equipmentTypeId'), createPathGuidParameter('equipmentTypeFieldId')],
        get: {
            operationId: 'equipmentTypeFieldControllers.getOne',
            responses: {
                '200': {
                    description: 'Single equipment type field',
                    content: {
                        'application/json': {
                            schema: equipmentTypeFieldSchema,
                        },
                    },
                },
                ...notFoundResponse,
            },
        },
        post: {
            operationId: 'equipmentTypeFieldControllers.update',
            requestBody: {
                content: {
                    'application/json': {
                        schema: equipmentTypeFieldCreateAndUpdateSchema,
                    },
                },
            },
            responses: {
                ...updatedResponse,
                ...notFoundResponse,
            },
        },
        delete: {
            operationId: 'equipmentTypeFieldControllers.remove',
            responses: {
                ...removedResponse,
                ...notFoundResponse,
            },
        },
    },
} as const;
